import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface ConfirmDialogData {
    title: string;
    message: string;
    icon?: string;
    confirmButtonText?: string;
    confirmButtonColor?: 'primary' | 'accent' | 'warn';
}

interface ConfirmDialogDataInternal {
    title: string;
    message: string;
    icon: string;
    confirmButtonText: string;
    confirmButtonColor: 'primary' | 'accent' | 'warn';
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
    data: ConfirmDialogDataInternal;

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) inputData: ConfirmDialogData
    ) {
        this.data = {
            title: inputData.title,
            message: inputData.message,
            icon: inputData.icon || 'total-fill-data',
            confirmButtonText: inputData.confirmButtonText || 'general.actions.ok',
            confirmButtonColor: inputData.confirmButtonColor || 'primary'
        };
    }
}
